(function () {
    'use strict';

    angular
        .module('franchisee.components')
        .controller('ApplicationsListController', ApplicationsListController)

    /** @ngInject */
    function ApplicationsListController($rootScope, $scope, ApplicationService, AuthenticationService, LoadingHelper, DATA_EVENTS) {
        const vm = this;

        vm.getImagePath = application => {
            return ImagePathHelper.imageHandlerPath('application', application.Id, application.Image);
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_COMPANY_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getApplications() {
            LoadingHelper.startLoading('.applications-list-holder');

            const permissionGroupId = AuthenticationService.getUser().PermissionGroup.Id;

            ApplicationService
                .getAllByPermissionGroup(permissionGroupId)
                .then(success => {
                    vm.applications = success;

                    LoadingHelper.stopLoading('.applications-list-holder');
                }, error => {
                    LoadingHelper.stopLoading('.applications-list-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function init() {
            getApplications();
        }
    }
}());